import {Injectable } from 'angular-ts-decorators';
import { Client, fetchExchange } from '@urql/core';

@Injectable('GraphqlClient')
export class GraphqlClient {
    public client = new Client({
      url: `/graphql`,
      exchanges: [ fetchExchange ],
      fetchOptions: () => {
        const token = localStorage.getItem('id_token');
        return {
          headers: { authorization: token ? `Bearer ${token}` : '' },
        };
      },
    });   
    
}
